import httpClient from "../http/http-client";
import { IFuelEnergyContentFactorImportLine } from './fuel-energy-content-factor-import-line.model';

export default class FuelEnergyContentFactorImportLineService {
  http;
  constructor() {
    this.http = httpClient
  }

  async getAll(queryParams?: string): Promise<IFuelEnergyContentFactorImportLine[]> {
    return this.http.get(`fuel-energy-content-factor-import-line${queryParams ? queryParams : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async edit(id: string, data: any): Promise<IFuelEnergyContentFactorImportLine> {
    return this.http.put(`fuel-energy-content-factor-import-line/${id}`, data)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

}